export enum EventActions{
    toggleDrawerMenu='TOGGLE_DRAWER_MENU'
}